// extracted by mini-css-extract-plugin
export default {"ag-styles":"D_M","detailCellRenderer":"D_cX"};